export const MOBILE_SCREEN_SIZE_WIDTH = 630;
export const TABLET_SCREEN_SIZE_WIDTH = 1030;

export const ApplicationType = {
  PDF: 'application/pdf'
};
export const DEFAULT_FILENAMES = {
  TRANSLATED: 'translated.pdf',
  DEFAULT: 'document.pdf'
};

export const MAX_RECONNECT_ATTEMPTS: number = 30;
export const RECONNECT_DELAY: number = 2000;

export const IOS_DEVICE_NAME = 'iOS';

export const DEVICE_SIZES_MAP = {
  '375': '375px',
  '630': '630px', // mobile
  '760': '760px',
  '1030': '1030px', // tablet
  '1200': '1200px',
  '1600': '1600px',
  '1920': '1920px',
  '2560': '2560px'
} as const;

export type MainColors =
  | 'orange'
  | 'blue'
  | 'violet'
  | 'pink'
  | 'green'
  | 'red'
  | 'purple'
  | 'dark-blue'
  | 'gray'
  | 'berry'
  | 'peach'
  | 'ocean-blue';

export const FEATURE_IDS = {
  COMPRESS: 'compress-pdf',
  MERGE: 'merge-pdf',
  SPLIT: 'split-pdf',
  PROTECT: 'password-protect-pdf',
  UNLOCK: 'unlock-pdf',
  SIGNATURE: 'sign-pdf',
  IMAGE: 'jpg-to-pdf',
  MERGE_IMAGES: 'merge-images',
  PDF_OCR: 'pdf-ocr',
  FILL_PDF: 'fill-pdf',
  TRANSLATE: 'translate-pdf'
};

export const GET_RESULT_COUNT_RETRIES: number = Number(process.env.REACT_APP_GET_RESULT_COUNT_RETRIES) || 80;

export const USA_COUNTRY_CODE = 'US';
export const UAE_COUNTRY_CODE = 'UAE';

export const ONE_TIME_PRODUCT_ID = '9386227f-5324-4c4a-9b4e-9a5108f784de';
